
//全局注册组件
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import ExamTips from '@/components/ExamTips.vue';
import Calculator from '@/components/Calculator.vue';

//数组存放接收的组件名
const components = [
    { name: 'Footer', con: Footer },
    { name: 'Header', con: Header },
    { name: 'ExamTips', con: ExamTips },
    { name: 'Calculator', con: Calculator },
]
//循环注册组件
const install = function (Vue, opts = {}) {
    components.forEach(component => {
        Vue.component(component.name, component.con);
    });
};

export default {
    install
};